"use client";

import { Check, Users } from "lucide-react";
import { useTranslations } from "next-intl";

export interface RegistrationFlowRegisteredBannerProps {
    count: number;
}

export function RegistrationFlowRegisteredBanner({
    count,
}: RegistrationFlowRegisteredBannerProps) {
    const t = useTranslations("strings.registrationFlow");

    return (
        <div className="mb-6 rounded-2xl border-2 border-fest-gold/30 bg-gradient-to-r from-fest-gold/10 via-fest-gold-soft/10 to-fest-gold/10 p-5 shadow-sm">
            <div className="flex items-start gap-4">
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-fest-gold to-fest-gold-mid">
                    <Users className="h-5 w-5 text-white" />
                </div>
                <div className="min-w-0 flex-1">
                    <h3 className="mb-1 text-lg font-bold text-fest-heading">
                        {t("registeredFormsTitle")}
                    </h3>
                    <p className="mb-2 text-sm text-fest-muted-text">
                        {t("registeredFormsLead", { count })}{" "}
                        {t("registeredFormsTail")}
                    </p>
                    <div className="flex items-center gap-2 text-xs text-fest-subtle-text">
                        <Check className="h-4 w-4 text-fest-apple-green" />
                        <span>{t("registeredFormsHint")}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
